import { Heading } from "@/ui";
import { useTranslations } from "@services/strings";

export const TopBanner = () => {
  const { t } = useTranslations();

  return (
    <div className="bg-slate-800">
      <div className="container flex flex-col gap-4 py-16 md:py-32 justify-center items-center">
        <Heading variant="heading" as="h1" className="text-white text-center">
          {t("pages.help.banner.title")}
        </Heading>
        <span className="text-slate-400 text-center">
          {t("pages.help.banner.description")}
        </span>
      </div>
    </div>
  );
};
